
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources05Off as ObiSources05OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-05-off.js';
 
 
 

 
 export const ObiSources05Off = createComponent({
   react: React,
   tagName: 'obi-sources-05-off',
   elementClass: ObiSources05OffElement,
   events: {
     
   }
  });
 
 